import React, { useEffect, useState, useCallback } from 'react';
import { adminApi } from '../../services/api';

const todayStr = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d.toISOString().slice(0, 10); };
const fmt = (d: string) => new Date(d).toLocaleString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const STATUSES = ['', 'PROCESSED', 'UNMATCHED', 'MALFORMED', 'FAILED', 'RESOLVED', 'SKIPPED'];

export const AdminReportScreen: React.FC = () => {
  const [from, setFrom] = useState(todayStr());
  const [to, setTo] = useState(todayStr());
  const [status, setStatus] = useState('');
  const [rows, setRows] = useState<any[]>([]);
  const [summary, setSummary] = useState<any>({ processedCount: 0, processedTotal: 0 });
  const [offset, setOffset] = useState(0);
  const limit = 50;

  const load = useCallback(async () => {
    const res = await adminApi.report({
      from: `${from}T00:00:00.000Z`,
      to: `${to}T23:59:59.999Z`,
      status: status || undefined,
      limit,
      offset,
    });
    setRows(res.data);
    setSummary(res.summary);
  }, [from, to, status, offset]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="admin-filters">
        <label>From<input type="date" value={from} onChange={(e) => { setOffset(0); setFrom(e.target.value); }} /></label>
        <label>To<input type="date" value={to} onChange={(e) => { setOffset(0); setTo(e.target.value); }} /></label>
        <label>Status
          <select value={status} onChange={(e) => { setOffset(0); setStatus(e.target.value); }}>
            {STATUSES.map((s) => <option key={s} value={s}>{s || 'All'}</option>)}
          </select>
        </label>
      </div>
      <p className="admin-muted">PROCESSED in range: {summary.processedCount} payments · R {Number(summary.processedTotal || 0).toFixed(2)}</p>
      <table className="admin-table">
        <thead>
          <tr><th>Date</th><th>Amount</th><th>Shop Code</th><th>Reference</th><th>Status</th><th>Matched By</th><th>Allocated To</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{fmt(r.processedAt)}</td>
              <td>R {Number(r.parsedAmount ?? 0).toFixed(2)}</td>
              <td>{r.shopCode || '-'}</td>
              <td>{r.parsedRef || '-'}</td>
              <td>{r.status}</td>
              <td>{r.matchedBy || '-'}</td>
              <td>{r.allocatedUserName ? `${r.allocatedUserName} (${r.allocatedUserPhone})` : '-'}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={7} className="admin-muted">No payments in this range.</td></tr>}
        </tbody>
      </table>
      <div style={{ marginTop: '1rem' }}>
        <button className="admin-btn dismiss" disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - limit))}>Prev</button>
        <button className="admin-btn dismiss" disabled={rows.length < limit} onClick={() => setOffset(offset + limit)}>Next</button>
      </div>
    </div>
  );
};
